module.exports = __webpack_public_path__ + "img/pic_Nantou.b61a81d7.jpg";